export default __webpack_public_path__ + "30e2047969effe86ab8a1cf55c76c946.svg";